import dayjs from 'dayjs';
import useIsIframe from '@/hooks/useIsIframe';
import { useTranslation } from 'react-i18next';
import { Link } from '../link';
import styles from './Footer.module.css';

function Footer() {
  const isIframe = useIsIframe();
  const { t } = useTranslation();

  if (isIframe) return null;

  return (
    <div className={styles.wrapperFooter}>
      &copy;
      {` ${dayjs().year()} Beatly. ${t('footer.copyright')}`}
      <Link href="https://www.beatly.com/latest-product-updates" target="_blank">
        {t('footer.productUpdates')}
      </Link>
      <Link href="https://www.beatly.com/info/privacy-pollicy" target="_blank">
        {t('footer.privacyPolicy')}
      </Link>
      <Link href="https://www.beatly.com/info/terms-of-service" target="_blank">
        {t('footer.termsOfService')}
      </Link>
      <Link href="https://www.beatly.com/info/cookie-pollicy" target="_blank">
        {t('footer.cookieSettings')}
      </Link>
    </div>
  );
}

export default Footer;
